import { Container } from "react-bootstrap";
import classes from "./ContainerHighlighted.module.scss";
import classNames from "classnames";
import { ReactBootstrapHTMLContainerProps } from "../../../types/htmlElementTypes";

interface Props extends ReactBootstrapHTMLContainerProps {}

const ContainerHighlighted = ({ children, className, ...htmlProps }: Props) => {
  return (
    <Container
      className={classNames(
        `container container-inner-spacing container-highlighted bg-primary container-inner-spacing`,
        className,
        classes.containerHighlighted
      )}
      {...htmlProps}
    >
      <div className="max-content-width mx-auto">{children}</div>
    </Container>
  );
};

export default ContainerHighlighted;
